import * as React from 'react';
import { useDispatch } from 'react-redux';
import { loadConfigAction } from './loadConfigAction';
import { loadFeatureFlagsAction } from './loadFeatureFlagsAction';
import { showLoginAnnouncementAction } from './showLoginAnnouncementAction';


/**
 * ConfigLoader: a component that renders nothing and retrieves configuration/feature flags from the API onMount
 *
 * PureComponent: true
 * Redux Connected: true
 */
const ConfigLoader: React.FC = () => {
  const dispatch = useDispatch();

  React.useEffect(
    () => {
      dispatch(loadConfigAction());
      dispatch(loadFeatureFlagsAction());
      dispatch(showLoginAnnouncementAction());
    },
    [dispatch],
  );

  return null;
};

export default ConfigLoader;
